import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Box } from "../../box/src";
import { Simplebar } from "../../simplebar/src";
import { Milestone } from './Milestone';
export const Timeline = (_a) => {
    var { children, direction = 'vertical', height, items, labelSize: timelineLableSize, width } = _a, otherProps = __rest(_a, ["children", "direction", "height", "items", "labelSize", "width"]);
    return (_jsx(Box, { overflow: "hidden", width: width, children: _jsx(Simplebar, { style: {
                height: 'inherit',
                width: 'inherit',
            }, children: _jsxs(Box, Object.assign({ as: "ul", flexDirection: direction === 'vertical' ? 'column' : 'row', m: 0, p: 0 }, otherProps, { children: [children, items === null || items === void 0 ? void 0 : items.map((_a, i) => {
                        var { labelSize = timelineLableSize, render } = _a, props = __rest(_a, ["labelSize", "render"]);
                        return typeof render === 'function' ? (_jsx(Fragment, { children: render(props) }, i)) : (_jsx(Milestone, Object.assign({ direction: direction, labelSize: labelSize }, props), i));
                    })] })) }) }));
};
//# sourceMappingURL=Timeline.js.map